import { useDispatch } from 'client/js/redux';
import { updateUser } from 'client/js/redux/domains/User/actions';
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useHistory } from 'react-router';
import type { UnregisterCallback } from 'react-router-dom';
import { getCurrentTimeInUTC } from '../../../main/support/dateUtils';
import { LEGAL_TERMS_CONDITIONS_LINK } from '../../support/gdprConstants';
import { Button, Link } from '../core';

export default function CookieBanner() {
  const [hide, setHide] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();
  const unlistenHistoryRef = useRef<UnregisterCallback | null>(null);

  const handleAcceptCookies = useCallback(async () => {
    await dispatch(
      updateUser({
        cookie_accept_date: getCurrentTimeInUTC(),
      })
    );
    setHide(true);
    window.location.reload();
  }, [dispatch]);

  const handleDeclineCookies = useCallback(async () => {
    await dispatch(
      updateUser({
        cookie_decline_date: getCurrentTimeInUTC(),
      })
    );
    if (unlistenHistoryRef.current) {
      unlistenHistoryRef.current();
    }
    setHide(true);
  }, [dispatch]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: ignored using `--suppress`
  useEffect(() => {
    const pathname = window.location.pathname;
    unlistenHistoryRef.current = history.listen((location) => {
      if (location.pathname !== pathname && pathname !== '/login') {
        handleAcceptCookies();
      }
    });

    return () => {
      if (unlistenHistoryRef.current) {
        unlistenHistoryRef.current();
      }
    };
  }, []);

  if (hide) {
    return null;
  }

  return (
    <div className="cookie-banner" data-testid="cookie-banner">
      <div className="h_px-40 h_py-10">
        <span className="h_fw-600">This website uses cookies.</span>{' '}
        <span>By continuing to use our website, you are agreeing to the use of our cookies and web beacons.</span>{' '}
        <Link testid="cookie-banner_learn-more" href={LEGAL_TERMS_CONDITIONS_LINK}>
          Learn More
        </Link>
        .
      </div>
      <div>
        <Button
          type="secondary"
          size="medium"
          testid="cookie-banner_decline"
          className="h_mend-10"
          onClick={handleDeclineCookies}
        >
          Decline
        </Button>
        <Button size="medium" testid="cookie-banner_accept" onClick={handleAcceptCookies}>
          Accept
        </Button>
      </div>
    </div>
  );
}
